// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3xaD4","info":"PatientInfo_info__2JYv4"};